<template>
	<v-card
		style="border-color: steelblue;"
		:class="[
			'encryption-test-result',
			result.success ? 'encryption-test-result--success' : 'encryption-test-result--error'
		]"
	>
		<v-card-text class="pa-3">
			<!-- Header -->
			<div class="d-flex align-center mb-2">
				<v-icon
					:color="result.success ? 'success' : 'error'"
					class="mr-2"
				>
					{{ result.success ? 'mdi-check-circle' : 'mdi-close-circle' }}
				</v-icon>
				<span class="font-weight-medium">
					{{ result.success ? 'Success' : 'Failed' }}
				</span>
			</div>

			<!-- Success Content -->
			<template v-if="result.success">
				<template v-if="!decryptOnly">
					<div class="result-section">
						<div
							class="text-caption text--secondary"
						>
							Original:
						</div>
						<div
							class="result-value"
						>
							{{ result.originalText }}
						</div>
					</div>

					<div class="result-section">
						<div
							class="text-caption text--secondary"
						>
							Encrypted:
						</div>
						<div
							class="result-value result-value--scrollable"
						>
							{{ result.encryptedText }}
						</div>
					</div>
				</template>

				<div class="result-section">
					<div
						class="text-caption text--secondary"
					>
						Decrypted:
					</div>
					<div
						class="result-value"
						:class="{
							'success--text': !decryptOnly && matches,
							'error--text': !decryptOnly && !matches
						}"
					>
						{{ result.decryptedText }}
					</div>
				</div>

				<div
					v-if="!decryptOnly && matches"
					class="d-flex align-center success--text mt-2"
				>
					<v-icon
						small
						color="success"
						class="mr-1"
					>
						mdi-check
					</v-icon>
					<span
						class="text-caption"
					>
						Decryption matches original
					</span>
				</div>
			</template>

			<!-- Error Content -->
			<template v-else>
				<div
					class="error--text"
				>
					{{ result.error }}
				</div>
			</template>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'encryption-test-result',

	props: {
		result: {
			type: Object,
			required: true
		},
		decryptOnly: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		matches: function () {
			return this.result.originalText === this.result.decryptedText
		}
	}
}
</script>

<style scoped>
.encryption-test-result--success {
	border-color: var(--v-success-base);
}

.encryption-test-result--error {
	border-color: var(--v-error-base);
}

.result-section {
	margin-bottom: 8px;
}

.result-value {
	padding: 8px;
	background-color: rgba(0, 0, 0, 0.05);
	border-radius: 4px;
	word-break: break-all;
}

.result-value--scrollable {
	max-height: 80px;
	overflow-y: auto;
}
</style>
